import React, { type ReactElement } from "react";
import { twMerge } from "tailwind-merge";

import { TYPO_STYLES } from "@/styles/typography";

type ProductFachProps = {
    fach: string;
};
export const ProductFachView = ({ fach }: ProductFachProps): ReactElement => {
    return (
        <div className="leading-6 flex gap-3 items-start flex-1">
            <span className={twMerge(TYPO_STYLES.icon(), "text-2xl")}>
                {String.fromCharCode(Number("0xe949"))}
            </span>
            <p className={twMerge(TYPO_STYLES.bodyNormal16(), "text-brandDark")}>{fach}</p>
        </div>
    );
};
